/**
 * 参数值
 */
export const PARAMS = [
  { id: "2", label: "名称" },
  { id: "1", label: "id" },
];

//type  根据不同的告警类型填写不同的规则
export const EVEN = [
  {
    id: 1001,
    label: "日用量越上限",
    code: ["100229", "100230", "100231", "100232", "100401", "100402", "1000"],
    type: 1,
  },
  {
    id: 1002,
    label: "月用量越上限",
    code: ["100229", "100230", "100231", "100232", "100401", "100402", "1000"],
    type: 1,
  },
  {
    id: 1003,
    label: "过压",
    code: ["101", "201", "202", "203", "249", "250", "251"],
    type: 2,
  },
  {
    id: 1004,
    label: "失压",
    code: ["101", "201", "202", "203", "249", "250", "251"],
    type: 2,
  },
  {
    id: 1005,
    label: "欠压",
    code: ["101", "201", "202", "203", "249", "250", "251"],
    type: 2,
  },
  {
    id: 1006,
    label: "过流",
    code: ["102", "207", "208", "209", "261", "262", "263"],
    type: 2,
  },
  {
    id: 1007,
    label: "失流",
    code: ["102", "207", "208", "209", "261", "262", "263"],
    type: 2,
  },
  {
    id: 1008,
    label: "断流",
    code: ["102", "207", "208", "209", "261", "262", "263"],
    type: 2,
  },
  {
    id: 1009,
    label: "反向",
    code: [
      "101",
      "102",
      "103",
      "211",
      "212",
      "213",
      "214",
      "215",
      "216",
      "217",
      "218",
    ],
    type: 3,
  },
  { id: 1010, label: "电压不平衡度越上限", code: ["235"], type: 2 },
  { id: 1011, label: "电流不平衡度越上限", code: ["242"], type: 2 },
  {
    id: 1012,
    label: "功率因数越下限",
    code: ["219", "220", "221", "222"],
    type: 2,
  },
  { id: 1013, label: "过负荷", code: ["103", "233"], type: 2 },
  {
    id: 1014,
    label: "有功功率越上限",
    code: ["211", "212", "213", "214"],
    type: 2,
  },
  {
    id: 1015,
    label: "无功功率越上限",
    code: ["215", "216", "217", "218"],
    type: 2,
  },

  { id: 1017, label: "零序电流越上限", code: ["210"], type: 2 },
  { id: 1018, label: "频率越下限", code: ["227"], type: 2 },
  { id: 1019, label: "需量越上限", code: ["228"], type: 2 },
  { id: 1020, label: "温度越上限", code: ["201"], type: 2 },
  { id: 1021, label: "压力越上限", code: ["404"], type: 2 },
  { id: 1031, label: "压力越下限", code: ["404"], type: 2 },
  { id: 1022, label: "合闸", code: ["601"], type: 4 },
  { id: 1023, label: "分闸", code: ["601"], type: 4 },
  { id: 1024, label: "状态切换", code: ["601"], type: 5 },
  {
    id: "1027",
    label: "温度越下限",
    code: ["501"],
    type: 2,
    enName: "TemperatureBeyondTheLowerLimit",
  },
  {
    id: "1028",
    label: "湿度越上限",
    code: ["502"],
    type: 2,
    enName: "HumidityOverTheUpperLimit",
  },
  {
    id: "1029",
    label: "湿度越下限",
    code: ["503"],
    type: 2,
    enName: "HumidityBeyondTheLowerLimit",
  },
  { id: "1030", label: "频率越上限", code: ["227"], type: 2 },
];

export const DF = [
  {
    item: 0.85,
    data: [
      { factor: "0.61", value: 14 },
      { factor: "0.62", value: 13 },
      { factor: "0.63", value: 12 },
      { factor: "0.64", value: 11 },
      { factor: "0.65", value: 10 },
      { factor: "0.66", value: 9.5 },
      { factor: "0.67", value: 9.0 },
      { factor: "0.68", value: 8.5 },
      { factor: "0.69", value: 8.0 },
      { factor: "0.70", value: 7.5 },
      { factor: "0.71", value: 7.0 },
      { factor: "0.72", value: 6.5 },
      { factor: "0.73", value: 6.0 },
      { factor: "0.74", value: 5.5 },
      { factor: "0.75", value: 5.0 },
      { factor: "0.76", value: 4.5 },
      { factor: "0.77", value: 4.0 },
      { factor: "0.78", value: 3.5 },
      { factor: "0.79", value: 3.0 },
      { factor: "0.80", value: 2.5 },
      { factor: "0.81", value: 2.0 },
      { factor: "0.82", value: 1.5 },
      { factor: "0.83", value: 1.0 },
      { factor: "0.84", value: 0.5 },
      { factor: "0.85", value: 0 },
      { factor: "0.86", value: -0.1 },
      { factor: "0.87", value: -0.2 },
      { factor: "0.88", value: -0.3 },
      { factor: "0.89", value: -0.4 },
      { factor: "0.90", value: -0.5 },
      { factor: "0.91", value: -0.65 },
      { factor: "0.92", value: -0.8 },
      { factor: "0.93", value: -0.95 },
      { factor: "0.94", value: -1.1 },
      { factor: "0.95", value: -1.1 },
      { factor: "0.96", value: -1.1 },
      { factor: "0.97", value: -1.1 },
      { factor: "0.98", value: -1.1 },
      { factor: "0.99", value: -1.1 },
      { factor: "1.00", value: -1.1 },
    ],
  },
  {
    item: 0.9,
    data: [
      { factor: "0.01", value: 143 },
      { factor: "0.02", value: 141 },
      { factor: "0.03", value: 139 },
      { factor: "0.04", value: 137 },
      { factor: "0.05", value: 135 },
      { factor: "0.06", value: 133 },
      { factor: "0.07", value: 131 },
      { factor: "0.08", value: 129 },
      { factor: "0.09", value: 127 },
      { factor: "0.10", value: 125 },
      { factor: "0.11", value: 123 },
      { factor: "0.12", value: 121 },
      { factor: "0.13", value: 119 },
      { factor: "0.14", value: 117 },
      { factor: "0.15", value: 115 },
      { factor: "0.16", value: 113 },
      { factor: "0.17", value: 111 },
      { factor: "0.18", value: 109 },
      { factor: "0.19", value: 107 },
      { factor: "0.20", value: 105 },
      { factor: "0.21", value: 103 },
      { factor: "0.22", value: 101 },
      { factor: "0.23", value: 99 },
      { factor: "0.24", value: 97 },
      { factor: "0.25", value: 95 },
      { factor: "0.26", value: 93 },
      { factor: "0.27", value: 91 },
      { factor: "0.28", value: 89 },
      { factor: "0.29", value: 87 },
      { factor: "0.30", value: 85 },
      { factor: "0.31", value: 83 },
      { factor: "0.32", value: 81 },
      { factor: "0.33", value: 79 },
      { factor: "0.34", value: 77 },
      { factor: "0.35", value: 75 },
      { factor: "0.36", value: 73 },
      { factor: "0.37", value: 71 },
      { factor: "0.38", value: 69 },
      { factor: "0.39", value: 67 },
      { factor: "0.40", value: 65 },
      { factor: "0.41", value: 63 },
      { factor: "0.42", value: 61 },
      { factor: "0.43", value: 59 },
      { factor: "0.44", value: 57 },
      { factor: "0.47", value: 55 },
      { factor: "0.46", value: 53 },
      { factor: "0.47", value: 51 },
      { factor: "0.48", value: 49 },
      { factor: "0.49", value: 47 },
      { factor: "0.50", value: 45 },
      { factor: "0.51", value: 43 },
      { factor: "0.52", value: 41 },
      { factor: "0.53", value: 39 },
      { factor: "0.54", value: 37 },
      { factor: "0.55", value: 35 },
      { factor: "0.56", value: 33 },
      { factor: "0.57", value: 31 },
      { factor: "0.58", value: 29 },
      { factor: "0.59", value: 27 },
      { factor: "0.60", value: 25 },
      { factor: "0.61", value: 23 },
      { factor: "0.62", value: 21 },
      { factor: "0.63", value: 19 },
      { factor: "0.64", value: 17 },
      { factor: "0.65", value: 15 },
      { factor: "0.66", value: 14 },
      { factor: "0.67", value: 13 },
      { factor: "0.68", value: 12 },
      { factor: "0.69", value: 11 },
      { factor: "0.70", value: 10 },
      { factor: "0.71", value: 9.5 },
      { factor: "0.72", value: 9 },
      { factor: "0.73", value: 8.5 },
      { factor: "0.74", value: 8 },
      { factor: "0.75", value: 7.5 },
      { factor: "0.76", value: 7 },
      { factor: "0.77", value: 6.5 },
      { factor: "0.78", value: 6 },
      { factor: "0.79", value: 5.5 },
      { factor: "0.80", value: 5 },
      { factor: "0.81", value: 4.5 },
      { factor: "0.82", value: 4 },
      { factor: "0.83", value: 3.5 },
      { factor: "0.84", value: 3 },
      { factor: "0.85", value: 2.5 },
      { factor: "0.86", value: 2 },
      { factor: "0.87", value: 1.5 },
      { factor: "0.88", value: 1 },
      { factor: "0.89", value: 0.5 },
      { factor: "0.90", value: 0 },
      { factor: "0.91", value: -0.15 },
      { factor: "0.92", value: -0.3 },
      { factor: "0.93", value: -0.45 },
      { factor: "0.94", value: -0.6 },
      { factor: "0.95", value: -0.75 },
      { factor: "0.96", value: -0.75 },
      { factor: "0.97", value: -0.75 },
      { factor: "0.98", value: -0.75 },
      { factor: "0.99", value: -0.75 },
      { factor: "1.00", value: -0.75 },
    ],
  },
];

//分项用电数据
export const itemColor = [
  {
    name: "办公用电",
    color: "#d48825",
  },
  {
    name: "空调用电",
    color: "#52CCA3",
  },
  {
    name: "照明用电",
    color: "#00AAFF",
  },
  {
    name: "消防用电",
    color: "#338a9d",
  },
  {
    name: "特殊用电",
    color: "#8673E6",
  },
  {
    name: "动力用电",
    color: "#CCCC00",
  },
  {
    name: "其他用电",
    color: "#3932a3",
  },
  {
    name: "应急用电",
    color: "#6224ab",
  },
  {
    name: "生产用电",
    color: "#6523ad",
  },
  {
    name: "非生产用电",
    color: "#9321a5",
  },
  {
    name: "辅助生产用电",
    color: "#bb2926",
  },
];
